import { useState, useEffect } from 'react';
import * as anchor from '@project-serum/anchor';
import { Connection, PublicKey, clusterApiUrl } from '@solana/web3.js';
import idl from '../components/ABI/kingdomofants.json'; // Adjust the path as necessary
import useSolanaWeb3 from '../hooks/useSolanaWeb3'; // Updated for Solana
import { useDispatch } from 'react-redux';

const programID = new PublicKey(idl.metadata.address);
const network = clusterApiUrl('devnet');
const opts = { preflightCommitment: 'processed' };

function useStakedAntDetails(stakedNftAddress) {
  const { wallet } = useSolanaWeb3();
  const [level, setLevel] = useState(null);
  const [remainPotions, setRemainPotions] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [stakedTime, setStakedTime] = useState(null);
  const [stakedAmount, setStakedAmount] = useState(null);
  
  const dispatch = useDispatch()

  const fetchStakedAntDetails = async () => {
    if (!wallet.connected || !stakedNftAddress) return;

    setIsLoading(true);
    const connection = new Connection(network, opts.preflightCommitment);
    const provider = new anchor.AnchorProvider(connection, wallet, opts.preflightCommitment);
    const program = new anchor.Program(idl, programID, provider);

    try {
      const [antStateAccount] = await PublicKey.findProgramAddress(
        [Buffer.from('ANT-STATE-SEED'), wallet.publicKey.toBuffer(), new PublicKey(stakedNftAddress).toBuffer()],
        programID
      );

      const antStateAccountContent = await program.account.antState.fetch(antStateAccount);
      console.log('Fetched staked ANT account content:', antStateAccountContent);

      setLevel(antStateAccountContent.level);
      setRemainPotions(antStateAccountContent.remainPotions);

      // Format stakedTime to show elapsed time in days and hours
      const now = new Date();
      const stakedTimeDate = new Date(antStateAccountContent.stakedTime * 1000); // Assuming stakedTime is a timestamp in seconds
      const elapsedTime = now - stakedTimeDate;
      const days = Math.floor(elapsedTime / (1000 * 60 * 60 * 24));
      const hours = Math.floor((elapsedTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      setStakedTime(`${days} D ${hours} H`);

      // Adjust stakedAmount by removing six zeros
      setStakedAmount(antStateAccountContent.stakedAmount / 1000000);
    } catch (error) {
      console.error('Failed to fetch staked ANT details:', error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchStakedAntDetails();
  }, [wallet, stakedNftAddress, programID, network]);

  return { level, remainPotions, stakedTime, stakedAmount, isLoading, fetchStakedAntDetails };
}

export default useStakedAntDetails;